import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
};

export default function Impressum() {
  return (
    <motion.main
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      data-testid="impressum-page"
    >
      <div className="pt-32 pb-24 px-6 md:px-12 max-w-3xl mx-auto">
        <p
          className="text-[#C1440E] text-xs tracking-[0.4em] uppercase mb-4"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Rechtliches
        </p>
        <h1
          className="text-5xl md:text-6xl font-extrabold uppercase text-[#F2EDE8] mb-12"
          style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
        >
          Impressum
        </h1>

        <div className="space-y-8" style={{ fontFamily: "'Outfit', sans-serif" }}>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">Angaben gemäß § 5 TMG</h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Klaus Teichmann<br />
              Atelier 77 – Eventlocation & Künstlerhof<br />
              Schattbachstraße 77<br />
              44803 Bochum (Laer)
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">Kontakt</h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Telefon: 0234 / 935 000 2<br />
              E-Mail: info@bochum-partyraum.de
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Klaus Teichmann<br />
              Schattbachstraße 77<br />
              44803 Bochum (Laer)
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">Haftungsausschluss</h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die
              Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr
              übernommen werden. Haftungsansprüche, welche sich auf Schäden materieller oder
              ideeller Art beziehen, die durch die Nutzung der dargebotenen Informationen
              verursacht wurden, sind grundsätzlich ausgeschlossen.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">Urheberrecht</h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
              Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
              bedürfen der schriftlichen Zustimmung des jeweiligen Autors.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#F2EDE8]/10">
          <Link
            to="/"
            className="text-[#C1440E] hover:text-[#D4A843] text-sm transition-colors"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </motion.main>
  );
}
